module.exports = __webpack_public_path__ + "img/Souq-Alattara-logo.97da881b.svg";